<template>
    <!-- //简单表格 -->
    <div class="Short_form">
        <el-table :data="tabledata" style="width: 100%" :stripe="true" :height="high" empty-text="暂无数据"
            :row-style="{ height: row_high }" :header-row-style="{ height: row_high == '84px' ? row_high : '' }"
            :cell-style="cellStyle" @cell-click="selectStu">
            <el-table-column :label="Title">
                <el-table-column v-for="(item, index) in construction" :key="index" :prop="item.fieldName"
                    :label="item.title" align="center" :formatter="slashType == 'close' ? undefined : formatCleanliness">
                </el-table-column>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['construction', 'tabledata', 'high', 'row_high', 'slashType', 'Title'],
    data() {
        return {
            termValue: null
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        formatCleanliness(row, column, cellValue, index) {
            if (cellValue === 0 || cellValue === '0%' || cellValue === '') {
                return '/';
            } else {
                return cellValue;
            }
        },
        cellStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (column.label == '班级') {
                return {
                    color: "#22a5f1",
                    textDecoration: 'underline'
                };
            }
        },
        async selectStu(row, column, cell, event) {
            if (column.label == '班级') {
                const routeUrl = this.$router.resolve({
                    path: '/newreport',
                    query: {
                        type: 'class',
                        schoolId: this.$route.query.schoolId,
                        schoolName: this.$route.query.schoolName,
                        fromType: 'multiRole',
                        showType: '101',
                        date: this.termValue,
                        ReportModule: 2,
                        classID:row.class_id,
                    }
                });
                window.open(routeUrl.href, '_blank')

            }
        },
        async getTermList() {
            this.$Api.DataScreen.queryTermList()
                .then(async res => {
                    this.termValue = res.data[0].key;
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.getTermList();
    },
}
</script>
<style scoped lang="less">
.Short_form {
    // width: 696px;

    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #e4e4e4;
        border-radius: 3px;
    }

    //滚动条的滑块
    ::-webkit-scrollbar-thumb {
        background-color: #c8c9cc;
        border-radius: 3px;
    }

    // height: 288px;

    /deep/.el-table {
        border-radius: 10px;
        border: 1px solid #E8E8E8;

        .el-table__body {
            width: 100% !important;
        }

        th {
            text-align: center;
            background: #F2FBF9;
            color: #01B58C;
        }
    }
}
</style>